// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__3E6i9"};